import Populator from './populator.js';
import CookieHelper from '../../utils/cookie.js';

export default class CookiePopulator extends Populator {

    populate() {
        const key = this.input.el.dataset.cookie;
        if (CookieHelper.has(key)) {
            const value = CookieHelper.get(key);
            if (value) {
                super.populate(value);                
            }
        }
    }

    static applies(input) {
        return input.el.dataset.cookie !== undefined;
    }
}
